import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { API } from "src/constants/api";
import { ApiCallWithLoader, errorUpdate } from "src/redux/reducers/LoaderSlice";
import TextInput from "src/components/TextInput";
import {
  ashaAuthIdState,
  updatedAsha,
  viewSuccessBannerOnDetils,
} from "src/redux/reducers/AuthAshaDetailsSlice";
import { Trans } from "react-i18next";
import Datepicker from "src/components/Datepicker";
import "../../styles/EditAshaProfile.scss";
import { Button } from "react-bootstrap";
import SelectOption from "src/components/SelectOption";
import Locations from "src/utility/Locations";
import moment from "moment";
import Utility from "src/utility/Utility";
import { stateRights } from "../../config/stateRights";
import { useLocation, useNavigate } from "react-router-dom";
import { AshaDetailsSchema } from "src/schemas/Patient.schema";
import ValidationError from "src/components/ValidationError";
import ConfirmationModal from "src/components/ConfirmationModal";
import { updateBreadcrum } from "src/redux/reducers/BreadcrumbSlice";
import { PAGE } from "src/constants/page";

const EditAshaProfile = () => {
  const authUserId: any = useAppSelector(ashaAuthIdState);
  const [ashaDetails, setAshaDetails] = useState<any>();
  const [startDate, setStartDate] = useState<any>();
  const [districts, setDistricts] = useState<any>(null);
  const [cities, setCities] = useState<any>(null);
  const [states, setStates] = useState<any>(null);
  const [stateName, setStateName] = useState<any>();
  const [districtName, setDistrictName] = useState<any>(null);
  const [selection, setSelection] = useState("dob");
  const [age, setAge] = useState<number>(0);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [validateOnChangeFlag, setvalidateOnChangeFlag] = useState(false);
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userLocation = useLocation();
  const todayDate = new Date();

  useEffect(() => {
    const fetchAshaAuthDetails = async () => {
      const requestDetails = {
        url: API.GET_USER_DETAILS,
        method: "POST",
        callType: "auth0",
        requestData: {
          userId: userLocation?.state?.ashaAuthId
            ? userLocation.state.ashaAuthId
            : authUserId?.authId?.userId,
        },
      };
      try {
        const fetchUser = await dispatch(ApiCallWithLoader(requestDetails));
        const birthDate = new Date(
          fetchUser?.payload?.user_metadata?.birthdate
        );
        const state = fetchUser?.payload?.user_metadata?.address?.region;
        const district =
          fetchUser?.payload?.user_metadata?.address?.locality?.split(",")[1];
        setAshaDetails(fetchUser?.payload);
        setStartDate(birthDate);
        setStateName(state);
        setDistrictName(district);
      } catch (error) {
        console.log("err", error);
      }
    };
    fetchAshaAuthDetails();
    fetchStates();
  }, []);

  useEffect(() => {
    fetchDistricts(stateName);
  }, [stateName]);

  useEffect(() => {
    getCities(stateName, districtName);
  }, [stateName, districtName]);

  const stateRight =
    stateRights[
      ashaDetails?.user_metadata?.address?.region
        .toLowerCase()
        .replace(/ /g, "")
    ];

  const fetchDistricts = async (stateName: any) => {
    return new Promise<void>(async (resolve, reject) => {
      const requestDetails = {
        url: API.DISTRICTS_BY_STATE.replace(":stateName", stateName),
        method: "GET",
      };
      try {
        const resp = await dispatch(ApiCallWithLoader(requestDetails));
        setDistricts(
          resp.payload?.entry?.map((location: any) => {
            return {
              value: location?.resource?.id,
              label: location?.resource?.name.toLowerCase(),
            };
          })
        );
        resolve(resp.payload);
      } catch (error) {
        dispatch(errorUpdate({ isError: true, error: error }));
        reject(error);
      }
    });
  };

  const fetchStates = async () => {
    try {
      const requestDetails = {
        url: API.STATES,
        method: "GET",
      };
      const resp = await dispatch(ApiCallWithLoader(requestDetails));
      setStates(
        await resp?.payload?.entry?.map((location: any) => {
          return {
            value: location?.resource?.id,
            label: location?.resource?.name.toLowerCase(),
          };
        })
      );
    } catch (err) {
      console.log("err", err);
    }
  };

  async function getCities(stateName: string, districtName: string) {
    setCities([]);
    if (stateName && districtName) {
      const getCitiesCountUrl = API.CITY_VILLAGE_BY_DISTRICTS.replace(
        ":state",
        stateName?.toLowerCase()
      ).replace(":district", districtName?.toLowerCase());
      const countRequestDetails = {
        url: `${getCitiesCountUrl}&_count=1`,
        method: "GET",
      };
      const getCityDataCount = await dispatch(
        ApiCallWithLoader(countRequestDetails)
      );
      const total_count = getCityDataCount?.payload?.total;
      const roleRequest_url = API.CITY_VILLAGE_BY_DISTRICTS.replace(
        ":state",
        stateName?.toLowerCase()
      ).replace(":district", districtName?.toLowerCase());
      const requestDetails = {
        url: `${roleRequest_url}&_count=${total_count}`,
        method: "GET",
      };
      const getCityData = await dispatch(ApiCallWithLoader(requestDetails));
      const cities = await Locations.getCityMapping(
        getCityData?.payload?.entry
      );
      setCities(cities || []);
    }
  }

  const formik = useFormik({
    initialValues: {
      firstName: ashaDetails?.given_name || "",
      lastName: ashaDetails?.family_name || "",
      birthDate: ashaDetails?.user_metadata?.birthdate || "",
      ashaId: ashaDetails?.username || "",
      mobileNumber:
        ashaDetails?.app_metadata.phone_number.toString().replace("+91", "") ||
        "",
      village:
        ashaDetails?.user_metadata?.address?.locality?.split(",")[0] || "",
      district:
        ashaDetails?.user_metadata?.address?.locality?.split(",")[1] || "",
      state: ashaDetails?.user_metadata?.address?.region || "",
      pincode: ashaDetails?.user_metadata?.address?.postal_code || "",
      subCenter:
        ashaDetails?.user_metadata?.organizations?.EODB?.sub_center || "",
      uphcPhc: ashaDetails?.user_metadata?.organizations?.EODB?.uphcPhc || "",
      selectedOption: "dob",
      age: "",
    },
    enableReinitialize: true,
    validateOnChange: validateOnChangeFlag,
    validationSchema: AshaDetailsSchema,
    onSubmit: (values: any) => {
      //
    },
  });

  const handleStateChange = async (option: any) => {
    try {
      const districtList: any = await fetchDistricts(option.target.value);
      formik.setFieldValue("state", option.target.value);
      setDistricts(
        districtList?.entry.map((location: any) => {
          return {
            label: location.resource.name,
            value: location.resource.id,
          };
        })
      );
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };

  const handleDistrictChange = async (option: any) => {
    try {
      formik.setFieldValue("district", option.target.value);
      setCities(await getCities(formik.values.state, option.target.value));
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };

  const handleSelectDate = (e: any) => {
    formik.setFieldValue("selectedOption", e.target.value);
    setSelection(e.target.value);
  };

  const handleInvalidDate = () => {
    formik.setFieldValue("birthDate", "");
    formik.setFieldError("birthDate", "invalid_practitioner_age");
  };
  const handleDate = (date: any) => {
    const dt = date.split("/");
    const age = Utility.getAge(`${dt[2]}-${dt[1]}-${dt[0]}`);

    if (parseInt(age) < 18) {
      formik.setFieldValue("birthDate", "");
      formik.setFieldError("birthDate", "invalid_practitioner_age");
      return;
    }
    formik.setFieldError("birthDate", "");
    formik.setFieldError("age", "");
    setStartDate(new Date(moment(date, "DD/MM/YYYY").format("MM-DD-YYYY")));
    formik.setFieldValue(
      "birthDate",
      moment(date, "DD/MM/YYYY").format("YYYY-MM-DD") === "Invalid date"
        ? ""
        : moment(date, "DD/MM/YYYY").format("YYYY-MM-DD")
    );
  };

  const handleSelectAge = (e: any) => {
    formik.setFieldValue("selectedOption", e.target.value);
    formik.setFieldValue("age", "");
    setAge(0);
    setSelection(e.target.value);
  };

  const handleAge = (e: any) => {
    const ageInYears = e.target.value;
    formik.setFieldValue("age", ageInYears);
    if (ageInYears) {
      if (ageInYears > 17 && ageInYears <= 100) {
        const dob = Utility.ageToDate(ageInYears); //yyyy-mm-dd
        setStartDate(new Date(moment(dob, "YYYY-MM-DD").format("MM-DD-YYYY")));
        formik.setFieldValue("birthDate", dob, false);
        formik.setFieldError("age", "");
      } else {
        formik.setFieldError("age", "invalid_practitioner_age");
      }
    } else {
      setStartDate(null);
      formik.setFieldValue("birthDate", "");
      formik.setFieldError("age", "invalid_practitioner_age");
    }
  };

  const updateBreadcrumWithName = (name: string) => {
    dispatch(
      updateBreadcrum({
        routeHistory: [
          {
            label: name || "",
            label_key: name || " ",
            path: PAGE.VIEW_USERS,
            id: "view_profile",
            value: "",
          },
        ],
        display: true,
      })
    );
  };

  const updateAsha = async (e: any) => {
    e.preventDefault();
    setShowConfirmationModal(false);
    const requestDetails = {
      url: API.UPDATE_USER,
      method: "POST",
      callType: "auth0",
      requestData: {
        userId: userLocation?.state?.ashaAuthId
          ? userLocation.state.ashaAuthId
          : authUserId?.authId?.userId,
        given_name: formik.values.firstName,
        family_name: formik.values.lastName,
        name: formik.values.firstName + " " + formik.values.lastName,
        user_metadata: {
          birthdate: formik.values.birthDate,
          address: {
            locality: formik.values.village + "," + formik.values.district,
            postal_code: formik.values.pincode,
            region: formik.values.state,
          },
          organizations: {
            EODB: {
              sub_center: formik.values.subCenter,
              uphcPhc: formik.values.uphcPhc,
            },
          },
        },
        username: formik.values.ashaId,
        app_metadata: {
          phone_number: Utility.addCountryCode(formik.values.mobileNumber),
        },
      },
    };
    try {
      const fetchUser = await dispatch(ApiCallWithLoader(requestDetails));
      setAshaDetails(fetchUser?.payload?.getUsersDetails);
      dispatch(updatedAsha({ updated: true }));
      dispatch(viewSuccessBannerOnDetils(true));
      updateBreadcrumWithName(requestDetails.requestData.name);
    } catch (error) {
      console.log("err", error);
    }
    navigate(-1);
  };

  const handleConfirmSubmit = async () => {
    setvalidateOnChangeFlag(true);
    let isValid = await formik.validateForm();
    const getLength = Object.keys(isValid).length;
    if (!getLength) {
      setShowConfirmationModal(true);
    }
  };

  const handleCancel = () => {
    dispatch(updatedAsha({ updated: false }));
    navigate(-1);
    setModal(true);
  };

  function selectCity(option: any) {
    formik.setFieldValue("village", option.target.value);
  }

  return (
    <>
      <div className="bg-light-gray">
        <div className="container ">
          <h2 className="heading">{"Edit Asha Profile"}</h2>
        </div>
      </div>
      <form
        className="container editAshaProfile"
        onSubmit={(e: any) => {
          setvalidateOnChangeFlag(true);
          formik.handleSubmit(e);
        }}
      >
        <p className="mandatoryField">
          <span>*</span>
          <Trans i18nKey={"mandatory_fields"}></Trans>
        </p>
        <div className="bg-light-gray paddingform">
          <h5 className="bg-light-blue p-2 heading">
            <Trans i18nKey={"basic_details"}></Trans>
          </h5>
          <div className="p-3 form-width">
            <div className="mt-1">
              <TextInput
                label="First Name"
                label_key="asha_first_name"
                type="text"
                id="firstName"
                maxLength={50}
                defaultValue={formik.values.firstName}
                value={formik.values.firstName}
                error={formik.errors.firstName}
                onChange={formik.handleChange}
                disabled={stateRight && stateRight.edit_asha.firstName}
                mandate={true}
              />
            </div>
            <div className="mt-4">
              <TextInput
                label="Last Name"
                label_key="asha_last_name"
                type="text"
                id="lastName"
                maxLength={50}
                defaultValue={formik.values.lastName}
                value={formik.values.lastName}
                error={formik.errors.lastName}
                onChange={formik.handleChange}
                mandate={true}
                disabled={stateRight && stateRight.edit_asha.last_name}
              />
            </div>
            <div className="row">
              {stateRight && stateRight.edit_asha.dob ? (
                <div>
                  <label className="label-1 mt-4">
                    <>
                      <Trans i18nKey={"birth_details"}></Trans>{" "}
                      <span className="mandetory">*</span>
                    </>
                  </label>
                  <div className="ms-1 mt-2">
                    <input
                      type="radio"
                      id="dob"
                      value="dob"
                      name="birthDate"
                      defaultChecked={true}
                      onChange={handleSelectDate}
                    />
                    <label
                      htmlFor="dob"
                      className={
                        selection === "dob"
                          ? "radioBtn-selected"
                          : "radioBtn-not-selected"
                      }
                    >
                      <Trans i18nKey={"birth_date"}></Trans>
                    </label>
                    <input
                      className="ml-2"
                      type="radio"
                      id="age"
                      name="birthDate"
                      value="age"
                      onChange={handleSelectAge}
                    />
                    <label
                      htmlFor="age"
                      className={
                        selection === "age"
                          ? "radioBtn-selected"
                          : "radioBtn-not-selected"
                      }
                    >
                      <Trans i18nKey={"age"}></Trans>
                    </label>
                    {!selection && (
                      <ValidationError
                        error_key={
                          formik.errors?.selectedOption?.toString() || ""
                        }
                      />
                    )}
                  </div>
                  {selection === "dob" && (
                    <div>
                      <Datepicker
                        value={startDate}
                        minDt={new Date(todayDate.getFullYear() - 100, 1, 1)} // passes 100 years less than the current year to the Datepicker component
                        onChange={handleDate}
                        ignoreValidation={true}
                        onError={handleInvalidDate}
                        error={formik.errors.birthDate}
                        testId={"dp-updatepatient"}
                        mandate={true}
                      />
                    </div>
                  )}
                  {selection === "age" && (
                    <TextInput
                      label_key="age_in_years"
                      type="number"
                      id="age"
                      maxLength={3}
                      defaultValue={formik.values.age}
                      value={formik.values.age}
                      error={formik.errors.age}
                      onChange={handleAge}
                    />
                  )}
                </div>
              ) : (
                <>
                  <label className="label-1 mt-3">
                    <Trans i18nKey="birth_date"></Trans>
                  </label>
                  <span className="p-label">
                    {startDate && Utility.formatDate(startDate)}
                  </span>
                </>
              )}
            </div>
            <div className="mt-4">
              <TextInput
                label="Asha Id"
                label_key="asha_id"
                type="text"
                id="ashaId"
                maxLength={10}
                defaultValue={formik.values.ashaId}
                value={formik.values.ashaId}
                error={formik.errors.ashaId}
                onChange={formik.handleChange}
                mandate={true}
                disabled={stateRight && stateRight.edit_asha.ashaId}
              />
            </div>
            <div className="mt-4">
              <TextInput
                label="Mobile Number"
                label_key="mobile_number"
                type="number"
                id="mobileNumber"
                maxLength={10}
                defaultValue={formik.values.mobileNumber}
                value={formik.values.mobileNumber}
                error={formik.errors.mobileNumber}
                onChange={formik.handleChange}
                mandate={true}
                disabled={stateRight && stateRight.edit_asha.mobileNumber}
              />
            </div>
          </div>
          <div className="bg-light-gray mt-5">
            <h5 className="bg-light-blue p-2 heading">
              <Trans i18nKey={"address_details"}></Trans>
            </h5>
            <div className="p-3 form-width">
              <div className="mt-4">
                <SelectOption
                  label="Village/Slum"
                  label_key="myProfile.village_slum"
                  options={cities}
                  onChange={(value: any) => {
                    selectCity(value);
                  }}
                  id={"village"}
                  defaultSelected={formik.values.village}
                  error={formik.errors.village}
                  disabled={stateRight && stateRight.edit_asha.village}
                  className={
                    !stateRight?.edit_asha?.village ? "disableAddress" : ""
                  }
                />
              </div>
              <div className="mt-4">
                <SelectOption
                  label={"district"}
                  label_key="district"
                  options={districts}
                  onChange={(value: any) => {
                    handleDistrictChange(value);
                  }}
                  id={"district"}
                  disabled={stateRight && stateRight.edit_asha.district}
                  defaultSelected={formik?.values?.district}
                  className={
                    !stateRight?.edit_asha?.district ? "disableAddress" : ""
                  }
                />
              </div>
              <div className="mt-4">
                <SelectOption
                  label={"State"}
                  label_key="state"
                  options={states}
                  onChange={(value: any) => {
                    handleStateChange(value);
                  }}
                  id={"state"}
                  disabled={stateRight && stateRight.edit_asha.state}
                  defaultSelected={formik.values.state}
                  className={
                    !stateRight?.edit_asha?.state ? "disableAddress" : ""
                  }
                />
              </div>
              <div className="mt-4">
                <TextInput
                  label="Pincode"
                  label_key="pincode"
                  type="number"
                  id="pincode"
                  maxLength={6}
                  defaultValue={formik.values.pincode}
                  value={formik.values.pincode}
                  error={formik.errors.pincode}
                  onChange={formik.handleChange}
                  mandate={true}
                  disabled={stateRight && stateRight.edit_asha.pincode}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="bg-light-gray mt-5">
          <h5 className="bg-light-blue p-2 heading">
            <Trans i18nKey={"myProfile.assign_location"}></Trans>
          </h5>
          <div className="p-3 form-width">
            <div className="mt-4">
              <SelectOption
                label="Village/Slum"
                label_key="myProfile.village_slum"
                options={cities}
                onChange={(value: any) => {
                  selectCity(value);
                }}
                id={"village"}
                defaultSelected={formik.values.village}
                disabled={stateRight && stateRight.edit_asha.villageAssigned}
                className={
                  !stateRight?.edit_asha?.villageAssigned
                    ? "disableAddress"
                    : ""
                }
              />
            </div>
            <div className="mt-4">
              <TextInput
                label="Sub Centres"
                label_key="sub_center"
                type="text"
                id="subCenter"
                maxLength={50}
                defaultValue={formik.values.subCenter}
                value={formik.values.subCenter}
                error={formik.errors.subCenter}
                onChange={formik.handleChange}
                mandate={true}
                disabled={stateRight && stateRight.edit_asha.subCenter}
              />
            </div>
            <div className="mt-4">
              <TextInput
                label="UPHC/PHC"
                label_key="upch_phc"
                type="text"
                id="uphcPhc"
                defaultValue={formik.values.uphcPhc}
                value={formik.values.uphcPhc}
                onChange={formik.handleChange}
                mandate={true}
                error={formik.errors.uphcPhc}
                disabled={stateRight && stateRight.edit_asha.UPHC_PHC}
              />
            </div>
          </div>
        </div>
        <div className=" btn-container mt-3 updatePatient">
          <div className="text-md-end text-end">
            <Button
              type="button"
              className={"btn-outline cancelButton"}
              onClick={handleCancel}
            >
              <Trans i18nKey={"cancel"}></Trans>
            </Button>
            <Button
              data-testid="contactDetailsSubmitBtn"
              className={"ms-2"}
              onClick={handleConfirmSubmit}
            >
              <Trans i18nKey={"save"}></Trans>
            </Button>
          </div>
        </div>
        {showConfirmationModal && (
          <ConfirmationModal
            onCancel={() => setShowConfirmationModal(false)}
            onYes={(e: any) => updateAsha(e)}
            onClose={() => setShowConfirmationModal(false)}
            comfirmMessage={true}
            name={formik?.values?.firstName + " " + formik?.values?.lastName}
            titleKey="save_asha_details"
            yesKey="continue"
            cancelkey="cancel"
            isCenter={true}
            updateAsha={true}
          />
        )}
      </form>
    </>
  );
};

export default EditAshaProfile;
